export const LAUNCH_DARKLY_CLIENT_SIDE_ID =
  import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_SIDE_ID ?? '';

export const DATADOG_RUM_APPLICATION_ID =
  import.meta.env.VITE_DATADOG_RUM_APPLICATION_ID ?? '';

export const DATADOG_RUM_CLIENT_TOKEN =
  import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN ?? '';

export const ENV = import.meta.env.VITE_ENV ?? '';

export const KNOCK_API_KEY = import.meta.env.VITE_KNOCK_API_KEY ?? '';

export const KNOCK_FEED_ID = import.meta.env.VITE_KNOCK_FEED_ID ?? '';

export const KNOCK_GUIDE_CHANNEL_ID =
  import.meta.env.VITE_KNOCK_GUIDE_CHANNEL_ID ?? '';
